const UTM_COOKIE_NAME = "cozy_utm";
const TRACKING_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_adgroup",
  "utm_term",
  "utm_content",
  "gclid",
  "device",
];

function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function readUtmParams(search = window.location.search) {
  const query = new URLSearchParams(search);

  return TRACKING_PARAM_KEYS.reduce((params, key) => {
    const value = query.get(key);

    if (!value) {
      return params;
    }

    return {
      ...params,
      [key]: value,
    };
  }, {});
}

export function getCookie(name) {
  const allCookies = document.cookie ? document.cookie.split("; ") : [];

  for (const item of allCookies) {
    const separatorIndex = item.indexOf("=");
    const key = separatorIndex === -1 ? item : item.slice(0, separatorIndex);

    if (key !== name) {
      continue;
    }

    const rawValue =
      separatorIndex === -1 ? "" : item.slice(separatorIndex + 1);
    return decodeURIComponent(rawValue);
  }

  return null;
}

export function setCookie(
  name,
  value,
  {
    maxAgeDays = 90,
    sameSite = "Lax",
    secure = window.location.protocol === "https:",
  } = {},
) {
  const maxAge = Math.floor(maxAgeDays * 24 * 60 * 60);
  const secureSegment = secure ? "; Secure" : "";

  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=${sameSite}${secureSegment}`;
}

export function readPersistedUtm() {
  const rawValue = getCookie(UTM_COOKIE_NAME);

  if (!rawValue) {
    return {};
  }

  try {
    const parsed = JSON.parse(rawValue);
    return isObject(parsed) ? parsed : {};
  } catch (error) {
    return {};
  }
}

export function persistUtmFromLocation() {
  const utmFromUrl = readUtmParams();
  const hasTrackingData = Object.keys(utmFromUrl).length > 0;

  if (!hasTrackingData) {
    return readPersistedUtm();
  }

  const mergedUtm = {
    ...readPersistedUtm(),
    ...utmFromUrl,
  };

  setCookie(UTM_COOKIE_NAME, JSON.stringify(mergedUtm));

  return mergedUtm;
}
